import { ReactNode, useState } from 'react';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Step, StepLabel, Stepper, Tooltip, Typography } from '@mui/material';
import { BillingStep } from '../../../components/BillingStep';
import { FinishStepper } from '../../../components/FinishStepper';
import { AuthContainer } from '../../../components/auth/AuthContainer';
import { LINKS, TOOLTIP_GO_TO_DASHBOARD } from '../../constants';
import { CHANGE_PLAN_STEPS } from '../../../../../shared/lib/constants';
import { StepperStep } from '../../../../../shared/lib/theme/styleConstants';
import { useMobileView } from '../../hooks/useMobileView';

export const ChangePlan = () => {
  const [activeStep, setActiveStep] = useState<number>(0);
  const [startIndex, setStartIndex] = useState<number>(0);
  const fromMobile = useMobileView();
  const navigate = useNavigate();

  const handleNext = () => {
    setActiveStep(2);
    setStartIndex(1);
  };

  const handleBillingCardChange = (val: boolean) => {
    setActiveStep(val ? 1 : 0);
  };

  const goToDasboard = () => {
    navigate(LINKS.DASHBOARD_LINK);
  };

  return (
    <AuthContainer onBoarding>
      <Box sx={{ width: '100%' }}>
        <Tooltip title={TOOLTIP_GO_TO_DASHBOARD} arrow>
          <IconButton sx={{ ml: 2, mt: 0 }} color="primary" onClick={goToDasboard}>
            <ArrowBack />
          </IconButton>
        </Tooltip>
        <Stepper sx={{ ...StepperStep, pt: 0, pb: 0, mb: fromMobile ? '-8px' : 0, marginTop: fromMobile ? '10px !important' : undefined }} activeStep={activeStep} alternativeLabel>
          {CHANGE_PLAN_STEPS.map(({ id, title }) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: ReactNode } = {};

            return (
              <Step key={id} {...stepProps} sx={{ px: 2 }}>
                <StepLabel {...labelProps} sx={fromMobile ? {
                  '& .MuiStepLabel-label': { fontSize: '11px' },
                  '& .MuiStepLabel-label.Mui-active': { fontSize: '11px' },
                  '& .MuiStepLabel-label.Mui-completed': { fontSize: '11px' },
                } : {}}>{title}</StepLabel>
              </Step>
            );
          })}
        </Stepper>

        <Typography variant="h5" textAlign="center" mt={fromMobile ? 0 : 2}>
          {CHANGE_PLAN_STEPS[activeStep].title}
        </Typography>

        <Box sx={{ px: 2 }}>
          {startIndex === 0
            ? <BillingStep handleNext={handleNext} onBillingCardChange={handleBillingCardChange} isChangePlan />
            : <FinishStepper isChangePlan />
          }
        </Box>
      </Box>
    </AuthContainer>
  );
};
